import CryptoJS from "crypto-js";

export const setCustomerProfileResponse = (data) => ({
  type: "SET_CUSTOMER_PROFILE_RESPONSE",
  payload: data,
});

export const setProfilePictureResponse = (data) => ({
  type: "SET_PROFILE_PICTURE_RESPONSE",
  payload: data,
});

export const setDefaultAddressModal_2 = (data) => ({
  type: "SET_DEFAULT_ADDRESS_MODAL_2",
  payload: data,
});

export const setEditProfileAddressModal = (data) => ({
  type: "SET_EDIT_PROFILE_ADDRESS_MODAL",
  payload: data,
});

export const setAddProfileAddressModal = (data) => ({
  type: "SET_ADD_PROFILE_ADDRESS_MODAL",
  payload: data,
});

export const setDeleteAddressModal_2 = (data) => ({
  type: "SET_DELETE_ADDRESS_MODAL_2",
  payload: data,
});

export const setDefaultAddress_2 = (data) => ({
  type: "SET_DEFAULT_ADDRESS_2",
  payload: data,
});

export const setDeleteAddress_2 = (data) => ({
  type: "SET_DELETE_ADDRESS_2",
  payload: data,
});

export const setAddProfileCardModal = (data) => ({
  type: "SET_ADD_PROFILE_CARD_MODAL",
  payload: data,
});

export const setDeleteProfileCardModal = (data) => ({
  type: "SET_DELETE_PROFILE_CARD_MODAL",
  payload: data,
});

export const setDefaultProfileCardModal = (data) => ({
  type: "SET_DEFAULT_PROFILE_CARD_MODAL",
  payload: data,
});

export const setDeleteProfileCard = (data) => ({
  type: "SET_DELETE_PROFILE_CARD",
  payload: data,
});

export const setDefaultProfileCard = (data) => ({
  type: "SET_DEFAULT_PROFILE_CARD",
  payload: data,
});

export const setEditProfileModal = (data) => ({
  type: "SET_EDIT_PROFILE_MODAL",
  payload: data,
});

export const setPostCustomerProfileResponse = (data) => ({
  type: "SET_POST_CUSTOMER_PROFILE_RESPONSE",
  payload: data,
});

export const setChangePasswordModal = (data) => ({
  type: "SET_CHANGE_PASSWORD_MODAL",
  payload: data,
});

export const setChangePasswordResponse = (data) => ({
  type: "SET_CHANGE_PASSWORD_RESPONSE",
  payload: data,
});

export const setIsOpenResetPasswordModal = (data) => ({
  type: "SET_RESET_PASSWORD_MODAL",
  payload: data,
});

export const setResetPasswordResponse = (data) => ({
  type: "SET_RESET_PASSWORD_RESPONSE",
  payload: data,
});

export const setUploadingProfileImage = (data) => ({
  type: "SET_UPLOADING_PROFILE_IMAGE",
  payload: data,
});
// const rootURL = "https://pndapi.drycleandepotdelivers.com/";

export const fetchCustomerProfile = (customerId, token) => {
  return async function (dispatch) {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/account/user-profile/${customerId}/`,
        {
          method: "GET",
          mode: "cors",
          headers: new Headers({
            Accept: "application/json, text/plain, */*",
            Authorization: "Token " + token,
            "Content-Type": "application/json",
          }),
        }
      );
      const result = await res.json();
      localStorage.setItem("userName", result?.first_name);
      dispatch(setCustomerProfileResponse(result));
      return result; // <-- return the data
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const postProfilePicture = (file, token) => {
  return async function (dispatch) {
    return await postPicture(
      `${process.env.REACT_APP_ROOT_URL}/Customer/UploadProfileImage`,
      file,
      token
    )
      .then((data) => {
        dispatch(setProfilePictureResponse(data));
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const postCustomerProfile = (customer, token) => {
  return async function (dispatch) {
    try {
      const data = await updateData(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/account/user-profile/${customer?.id}/`,
        customer,
        token
      );

      dispatch(setPostCustomerProfileResponse(data));

      return data;
    } catch (error) {
      console.error(error);

      return {
        error: true,
        message: error.message,
      };
    }
  };
};

export const postChangePassword = (viewModel, token) => {
  return async function (dispatch) {
    try {
      const data = await postData(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/account/change-password/`,
        viewModel,
        token
      );

      dispatch(setChangePasswordResponse(data));

      if (data && !data.error) {
        // Encrypt and update only password in localStorage
        const passwordEncrypted = CryptoJS.AES.encrypt(
          JSON.stringify(viewModel.new_password),
          process.env.REACT_APP_SECRET_PASSWORD_KEY
        ).toString();

        localStorage.setItem("password", passwordEncrypted);
      }

      return data;
    } catch (error) {
      console.error("postChangePassword error:", error);

      dispatch(setChangePasswordResponse({ error: true, message: "Network error" }));

      return { error: true, message: error?.message || "Network error" };
    }
  };
};

export const postResetPassword = (viewModel) => {
  return async function (dispatch) {
    return await postResetPwdData(
      `${process.env.REACT_APP_DEV_PYTHON_URL}/account/reset-password/`,
      viewModel
    )
      .then((data) => {
        dispatch(setResetPasswordResponse(data));
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const deleteAccount = (userId, token) => {
  return async function (dispatch) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_DEV_PYTHON_URL}/account/${userId}/`,
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
            ...(token ? { Authorization: "Token " + token } : {}),
          },
        }
      );
      let data = {};
      try {
        data = await response.json();
      } catch (e) {
        data = { status: response.status, statusText: response.statusText };
      }
      return data;
    } catch (error) {
      console.error("deleteAccount error:", error);
      throw error;
    }
  };
};

const postData = async (url = "", data = {}, token) => {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json, text/plain, */*",
      Authorization: "Token " + token,
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

const postResetPwdData = async (url = "", data = {}) => {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json, text/plain, */*",
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

const updateData = async (url = "", data = {}, token) => {
  const response = await fetch(url, {
    method: "PUT",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json, text/plain, */*",
      Authorization: "Token " + token,
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

const postPicture = async (url = "", data, token) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: token,
    },
    body: data,
  });
};
